import { useEffect, useRef } from 'react';
import Hls from 'hls.js';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

export default function VideoPlayer({ src, className = '' }) {
    const videoRef = useRef(null);
    const hlsRef = useRef(null);
    const plyrRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video || !src) return;

        // Plyr options
        const plyrOptions = {
            controls: [
                'play-large', 'rewind', 'play', 'fast-forward',
                'progress', 'current-time', 'duration',
                'mute', 'volume',
                'settings', 'pip', 'airplay', 'fullscreen',
            ],
            settings: ['quality', 'speed'],
            speed: { selected: 1, options: [0.5, 0.75, 1, 1.25, 1.5, 2] },
            i18n: {
                restart: 'Qayta boshlash',
                rewind: '{seektime} soniya orqaga',
                play: "O'ynatish",
                pause: 'To\'xtatish',
                fastForward: '{seektime} soniya oldinga',
                seek: 'Qidirish',
                seekLabel: '{currentTime} / {duration}',
                played: "O'ynaldi",
                buffered: 'Yuklandi',
                currentTime: 'Joriy vaqt',
                duration: 'Davomiylik',
                volume: 'Ovoz',
                mute: 'Ovozsiz',
                unmute: 'Ovozli',
                enableCaptions: 'Subtitrlarni yoqish',
                disableCaptions: "Subtitrlarni o'chirish",
                enterFullscreen: "To'liq ekran",
                exitFullscreen: "To'liq ekrandan chiqish",
                frameTitle: '{title} uchun pleer',
                captions: 'Subtitrlar',
                settings: 'Sozlamalar',
                pip: 'Kichik oyna',
                menuBack: 'Orqaga',
                speed: 'Tezlik',
                normal: 'Oddiy',
                quality: 'Sifat',
                loop: 'Takrorlash',
            },
            tooltips: { controls: true, seek: true },
            keyboard: { focused: true, global: false },
        };

        if (Hls.isSupported()) {
            const hls = new Hls({
                enableWorker: true,
                lowLatencyMode: false,
            });
            hls.loadSource(src);
            hls.attachMedia(video);
            hlsRef.current = hls;

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                plyrRef.current = new Plyr(video, plyrOptions);
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari native HLS
            video.src = src;
            plyrRef.current = new Plyr(video, plyrOptions);
        }

        return () => {
            if (plyrRef.current) {
                plyrRef.current.destroy();
                plyrRef.current = null;
            }
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
        };
    }, [src]);

    return (
        <div className={`plyr-wrapper rounded-xl overflow-hidden bg-black ${className}`}>
            <video ref={videoRef} crossOrigin="anonymous" playsInline />
        </div>
    );
}
